module.exports = __webpack_public_path__ + "static/media/tapattendInvert.2703d421.jpg";